import { Injectable, Inject, PLATFORM_ID } from '@angular/core';
import { isPlatformBrowser } from '@angular/common';
import { CanActivate, Router, ActivatedRouteSnapshot } from '@angular/router';
import { Observable, of, filter, map, take } from 'rxjs';
import { AuthenticationService } from '../services/authentication.service';

@Injectable({
  providedIn: 'root',
})
export class authGuard implements CanActivate {
  constructor(
    private router: Router,
    private authService: AuthenticationService,
    @Inject(PLATFORM_ID) private platformId: Object
  ) {}

  canActivate(route: ActivatedRouteSnapshot): Observable<boolean> {
    // Skip authentication checks during SSR
    if (!isPlatformBrowser(this.platformId)) {
      return of(true);
    }

    return this.authService.isAuthenticated$.pipe(
      filter((val) => val !== null),
      take(1),
      map((isAuthenticated) => {
        const isLoginPage = (route.routeConfig?.path == 'login') || (route.routeConfig?.path == '');

        if (isLoginPage && isAuthenticated) {
          this.router.navigate(['/crm/general']);
          return false;
        }

        if (!isLoginPage && !isAuthenticated) {
          this.router.navigate(['/login']);
          return false;
        }

        return true;
      })
    );
  }
}
